<template>

    <q-modal v-model="showCheckDialog"  no-backdrop-dismiss>
            <q-toolbar>
                    <q-toolbar-title>
                        Проверка и запуск заказа № {{orderId}}
                    </q-toolbar-title>
            </q-toolbar>
            <div style="width:550px; height:250px" class='row justify-center items-center' v-if='isChecking'>
                <q-spinner color="primary" :size="100" />
            </div>
            <!-- выводим результат проверки всего этого безобразия -->
            <div v-if='!isChecking' style="width:550px; height:250px; overflow-y:auto" class="q-pa-md"> 
                <div v-for='(item, key) in statusInfo' :key=key>
                    <div class='ellipsis q-subheading q-ma-sm text-weight-bold' v-bind:class="{'text-red' : !item.status, 'text-green' : item.status}">
                        {{item.fileMsg}}
                        <div v-if='!item.status' class='q-caption text-weight-regular q-ml-md'>
                            <div v-for="(msg, key) in item.errorMsg" :key=key >
                                {{msg}}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <q-card-separator/>
            <div class='q-pa-sm row justify-end'>
                <div v-if='!isChecking'>
                    <q-btn label='отмена' color='negative' outline class='q-ma-sm' @click='cancelDialog'/>
                    <q-btn label='Запустить в работу' color='positive' class='q-ma-sm' v-if='mainCorrect' @click='toWork'/>
                    <q-btn label='Все равно запустить в работу' color='negative' class='q-ma-sm' v-if='!mainCorrect' @click='toWork'/>
                </div>
            </div>
    </q-modal>

</template>

<script>
/* eslint-disable */
export default {

    name : 'checkOrderDialog1',

    data() {
        return {
            showCheckDialog : false,
            isChecking : false,
            orderId : null,
            files : [],
            statusInfo : [],
            mainCorrect : true,
        }
    },

    created() {
        eventBus.$on('showCheckDialog', (orderId)=>{
            this.showCheckDialog = true;
            this.isChecking = true;
            this.orderId = orderId;
            this.files = [];
            this.statusInfo = [];
            // загружаем данные файлов
            this.$store.dispatch('getDetailsFiles', orderId)
            .then(result => {
                
                this.mainCorrect = true; // Предполагаем что все заебись
                this.files = result;
                var fileNumber = 0;

                result.forEach(element => { // бежим по файлам
                    let fileStatus = true; // изначально предполагаем что статус файла ок.
                    let errorMsg = []; //Ошибки файла
                    fileNumber ++;
                    let fileMsg = 'Файл '+fileNumber+' проверен: ';
                    let opt = element.options != null ? JSON.parse(element.options) : {};
                    if ((opt.width == null) || (opt.height == null)) { // если не задан размер
                        fileStatus = false;
                        errorMsg.push('Не заданы размеры')
                    }
                    if (opt.material == null) {
                        fileStatus = false;
                        errorMsg.push('Не задан материал');
                    }
                    if (opt.stanok == null) {
                        fileStatus = false;
                        errorMsg.push('Не задан станок');
                    }
                    fileMsg = fileMsg + (fileStatus ? 'статус ОК' : 'статус с ошибками');
                    this.statusInfo.push({status:fileStatus, fileMsg:fileMsg, errorMsg : errorMsg});
                    this.mainCorrect = !fileStatus ? fileStatus : this.mainCorrect; // устанавливаем флаг майнОшибки
                });
                this.isChecking = false; // снимаем флаг загрузки и проверки
            })
            .catch(error => {
                console.log(error);
            })
        });

    },

    beforeDestroy() {
        eventBus.$off('showCheckDialog');
    },

    methods : {
        cancelDialog() {
            this.showCheckDialog = false;
        },

        toWork() {
            this.$store.dispatch('setToWork', this.orderId)
            .then(()=>{
                this.$admns.showNotify("Заказ №"+this.orderId+ " запущен в работу.","success","Сообщение системы")
                this.showCheckDialog = false;
            })
            .catch(()=>{
                this.$admns.showNotify("Заказ №"+this.orderId+ " не запущен.","error","Сообщение системы")
            });
        }
    },

    calculate : {

    }

}
</script>


